import { FC } from 'react'
import clsx from 'clsx'
import { INotesBar, paddingTopClassMap, paddingBottomClassMap } from '@common/pd-meta-components-types'
import TitleAndDesc from '../../title-and-desc'

const NotesBar: FC<INotesBar> = ({ theme, dataList, paddingTop = 'px64', paddingBottom = 'px64' }) => {
  if (!dataList.length) {
    return null
  }

  return (
    <div className={clsx('w-full', paddingTopClassMap[paddingTop], paddingBottomClassMap[paddingBottom], `pd-theme-${theme}`, 'bg-container-primary')}>
      <div className={clsx('w-full', 'laptop:mx-auto laptop:w-300', 'border-b border-bd-primary', 'px-6 laptop:px-0')}>
        {/* 如果title为空，则不显示 */}
        {dataList
          .filter((item) => item.title)
          .map((item, index) => (
            <div key={index} className={clsx('flex flex-col gap-y-1')}>
              <h2 className={clsx('whitespace-pre-wrap', 'text-14', 'text-fc-secondary')}>{item.title}</h2>
              <p className={clsx('whitespace-pre-wrap', 'text-14', 'mb-3', 'laptop:mb-5', 'text-fc-secondary')}>
                {item.desc}
              </p>
            </div>
          ))}
      </div>
    </div>
  )
}

export default NotesBar
